/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 2dMe7XWUq916KsPnra5vYj
// Component: FvbTyDpXOYV

import * as React from "react";

import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  Flex as Flex__,
  renderPlasmicSlot,
  StrictProps,
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";

import RedirectUriRow from "../../components/app-auth/RedirectUriRow"; // plasmic-import: Wx1WB4BUap/component
import Button from "../../components/widgets/Button"; // plasmic-import: SEF-sRmSoqV5c/component
import IconButton from "../../components/widgets/IconButton"; // plasmic-import: LPry-TF4j22a/component
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: 2dMe7XWUq916KsPnra5vYj/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import "./plasmic_plasmic_kit_end_user_management.css"; // plasmic-import: 2dMe7XWUq916KsPnra5vYj/projectcss
import sty from "./PlasmicRedirectUrIsControl.module.css"; // plasmic-import: FvbTyDpXOYV/css

import ArrowRightSvgIcon from "../plasmic_kit_icons/icons/PlasmicIcon__ArrowRightSvg"; // plasmic-import: 9Jv8jb253/icon
import ChevronDownSvgIcon from "../plasmic_kit_icons/icons/PlasmicIcon__ChevronDownSvg"; // plasmic-import: xZrB9_0ir/icon
import PlusSvgIcon from "../plasmic_kit_icons/icons/PlasmicIcon__PlusSvg"; // plasmic-import: sQKgd2GNr/icon

createPlasmicElementProxy;

export type PlasmicRedirectUrIsControl__VariantMembers = {};
export type PlasmicRedirectUrIsControl__VariantsArgs = {};
type VariantPropType = keyof PlasmicRedirectUrIsControl__VariantsArgs;
export const PlasmicRedirectUrIsControl__VariantProps =
  new Array<VariantPropType>();

export type PlasmicRedirectUrIsControl__ArgsType = { uris?: React.ReactNode };
type ArgPropType = keyof PlasmicRedirectUrIsControl__ArgsType;
export const PlasmicRedirectUrIsControl__ArgProps = new Array<ArgPropType>(
  "uris"
);

export type PlasmicRedirectUrIsControl__OverridesType = {
  root?: Flex__<"div">;
  columns?: Flex__<"div">;
  redirectsLabel?: Flex__<"div">;
  saveBtn?: Flex__<typeof Button>;
  addBtn?: Flex__<typeof IconButton>;
};

export interface DefaultRedirectUrIsControlProps {
  uris?: React.ReactNode;
  className?: string;
}

const $$ = {};

function PlasmicRedirectUrIsControl__RenderFunc(props: {
  variants: PlasmicRedirectUrIsControl__VariantsArgs;
  args: PlasmicRedirectUrIsControl__ArgsType;
  overrides: PlasmicRedirectUrIsControl__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants,
  };

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "root_reset_2dMe7XWUq916KsPnra5vYj",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.root
      )}
    >
      <div
        data-plasmic-name={"columns"}
        data-plasmic-override={overrides.columns}
        className={classNames("all", sty.columns)}
      >
        <div className={classNames("all", sty.column__vp43W)}>
          <div
            data-plasmic-name={"redirectsLabel"}
            data-plasmic-override={overrides.redirectsLabel}
            className={classNames("all", "__wab_text", sty.redirectsLabel)}
          >
            {"Redirect URIs"}
          </div>
        </div>
        <div className={classNames("all", sty.column__nsFLe)}>
          <Button
            data-plasmic-name={"saveBtn"}
            data-plasmic-override={overrides.saveBtn}
            className={classNames("__wab_instance", sty.saveBtn)}
            endIcon={
              <ChevronDownSvgIcon
                className={classNames("all", sty.svg__qmGoV)}
                role={"img"}
              />
            }
            size={"wide"}
            startIcon={
              <ArrowRightSvgIcon
                className={classNames("all", sty.svg__txmU)}
                role={"img"}
              />
            }
          >
            {"Save"}
          </Button>
        </div>
        <div className={classNames("all", sty.column__zTZy)}>
          <IconButton
            data-plasmic-name={"addBtn"}
            data-plasmic-override={overrides.addBtn}
            children2={
              <ChevronDownSvgIcon
                className={classNames("all", sty.svg__gjmZl)}
                role={"img"}
              />
            }
            className={classNames("__wab_instance", sty.addBtn)}
          >
            <PlusSvgIcon
              className={classNames("all", sty.svg__dLtG2)}
              role={"img"}
            />
          </IconButton>
        </div>
      </div>
      {renderPlasmicSlot({
        defaultContents: (
          <React.Fragment>
            <RedirectUriRow
              className={classNames(
                "__wab_instance",
                sty.redirectUriRow___6FCp
              )}
            />

            <RedirectUriRow
              className={classNames("__wab_instance", sty.redirectUriRow__xx7V)}
            />
          </React.Fragment>
        ),
        value: args.uris,
      })}
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root", "columns", "redirectsLabel", "saveBtn", "addBtn"],
  columns: ["columns", "redirectsLabel", "saveBtn", "addBtn"],
  redirectsLabel: ["redirectsLabel"],
  saveBtn: ["saveBtn"],
  addBtn: ["addBtn"],
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  columns: "div";
  redirectsLabel: "div";
  saveBtn: typeof Button;
  addBtn: typeof IconButton;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicRedirectUrIsControl__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicRedirectUrIsControl__VariantsArgs;
    args?: PlasmicRedirectUrIsControl__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & // Specify variants directly as props
  Omit<PlasmicRedirectUrIsControl__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicRedirectUrIsControl__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicRedirectUrIsControl__ArgProps,
          internalVariantPropNames: PlasmicRedirectUrIsControl__VariantProps,
        }),
      [props, nodeName]
    );
    return PlasmicRedirectUrIsControl__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName,
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicRedirectUrIsControl";
  } else {
    func.displayName = `PlasmicRedirectUrIsControl.${nodeName}`;
  }
  return func;
}

export const PlasmicRedirectUrIsControl = Object.assign(
  // Top-level PlasmicRedirectUrIsControl renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    columns: makeNodeComponent("columns"),
    redirectsLabel: makeNodeComponent("redirectsLabel"),
    saveBtn: makeNodeComponent("saveBtn"),
    addBtn: makeNodeComponent("addBtn"),

    // Metadata about props expected for PlasmicRedirectUrIsControl
    internalVariantProps: PlasmicRedirectUrIsControl__VariantProps,
    internalArgProps: PlasmicRedirectUrIsControl__ArgProps,
  }
);

export default PlasmicRedirectUrIsControl;
/* prettier-ignore-end */
